import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Observable, Subject, EMPTY } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { UseCasesService } from '../use-cases.service';

@Component({
  selector: 'qw-use-case-filters',
  templateUrl: './use-case-filters.component.html',
  styleUrls: ['./use-case-filters.component.scss']
})
export class UseCaseFiltersComponent implements OnInit {

  currentCategory = 'All use-cases';
  categories$ = new Observable();
  categoriesError$ = new Subject();

  @Output() onFilter = new EventEmitter();

  constructor(private useCasesService: UseCasesService) { }

  ngOnInit() {
    this.getCategories();
  }

  getCategories() {
    this.categoriesError$.next(undefined);
    this.categories$ = this.useCasesService.getUseCasesCategories().pipe(
      map(categories => categories.filter(this.getDistinctApps)),
      map(categories => ['All use-cases', ...categories]),
      catchError((error: HttpErrorResponse) => {this.categoriesError$.next(error); return EMPTY; })
    );
  }

  getDistinctApps(value, index, self) {
    return self.indexOf(value) === index;
  }

  filterUseCases(value: string, key: string) {
    this.onFilter.emit({
      category: value
    });
  }

}
